export default __webpack_public_path__ + "static/media/bg5.b98b97c1.jpg";